import React from "react";
import _ from "lodash";
import { Box } from "@mui/material";
import { OcRequestsMessagesCard } from "oc/components";

interface MyLeaveCardMessageBoxProps {
  leaveRequest: {
    messages?: any[];
    [key: string]: any;
  };
  loading?: boolean;
  disabled?: boolean;
  role?: string;
}

export const MyLeaveCardMessageBox: React.FC<MyLeaveCardMessageBoxProps> = ({
  leaveRequest,
  loading,
  disabled,
  role,
}) => {
  let messages = leaveRequest?.messages
    ? _.cloneDeep(leaveRequest.messages)
    : [];

  return (
    <Box>
      <OcRequestsMessagesCard
        messages={messages}
        module="MyLeave"
        loading={loading ?? false}
        data={leaveRequest}
        disabled={disabled ?? false}
        role={role ?? ""}
      />
    </Box>
  );
};

export default MyLeaveCardMessageBox;
